<template>
    <!-- SEASONS-->
    <section class="page-section bg-dark" id="seasons">
        <div class="container">
            <div class="text-center">
                <h2 class="section-heading text-uppercase text-white">SEASONS</h2>
                <h3 class="section-subheading text-white">Team 7770 has been competing in the FIRST Robotics Competition
                    since 2019.</h3>
            </div>
            <div>
                <div v-for="season in seasons" v-bind:key="season" class="container col-md-12 bg-white rounded p-2 m-2">
                    <div class="row">
                        <div class="col-2">
                            <p><img :src="season.image" height="125" width="125" /></p>
                            
                        </div>
                        <div class="col-sm">
                        <div class="card bg-light">
                            <div class="card-header">{{ season.year }} - {{ season.name }}</div>
                            <div class="card-body">
                                <h5 class="card-title">Robot: {{ season.robot }}</h5>
                                <h5 class="card-title">Features:</h5>
                                <ul class="card-text">
                                    <li v-for="feature in season.features" v-bind:key="feature">{{ feature }}</li>
                                </ul>
                                <h5 class="card-title">Awards:</h5>
                                <ul>
                                    <li v-for="award in season.awards" v-bind:key="award">{{ award }}</li>
                                </ul>
                            </div>
                            <div class="card-body">
                                <iframe height="225" :src="`https://www.youtube.com/embed/${season.youtube}`" title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                            </div>                            
                            <div class="card-header section-heading text-uppercase text-white">
                                <a :href="`https://www.thebluealliance.com/team/7770/${season.year}`" target="_results" class="results-link">Results</a>
                            </div>
                        </div>
                        </div>
                        <div class="col-sm">
                            <img class="img-fluid" :src="season.pic" height="350" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script setup lang="ts">
import { seasons } from '@/data/seasons'
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.results-link {
    color: #000000;
    font-weight: bold;
    text-decoration: none;
}
</style>